import React, { useState } from 'react'
import { createContext } from "react";
import eventMainImage from '../assets/Eventsmainimg.png'
import news1 from '../assets/NewsImage.png'
import EventImage1 from '../assets/EventImage1.png'
import EventImage2 from '../assets/EventImage2.png'
import EventImage3 from '../assets/EventImage3.png'

export const EventsContext = createContext()
function EventsContextProvider({ children }) {
  const [allEvenst, setAllEvents] = useState([])
  const [albumId, setAlbumId] = useState(null)
  const [eventId, setEventId] = useState(null)
  const [radioData, setRadioData] = useState(null);
  const [topEvents, setTopEvents] = useState([])
  const [allAlbums, setAllAlbums] = useState(null)
  const [images, setImages] = useState(null);
  const [mySlider, setMySlider] = useState(false)
  const [toShow, setToShow] = useState(false)

  return (
    <EventsContext.Provider value={{ allEvenst, setAllEvents, albumId, setAlbumId, eventId, setEventId, topEvents, setTopEvents, radioData, setRadioData, allAlbums, setAllAlbums, images, setImages, mySlider, setMySlider, toShow, setToShow }} >
      {children}
    </EventsContext.Provider>

  )
}

export default EventsContextProvider